import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classes from "./ContatoPage.module.css";
import { faCircleInfo, faPaperPlane, faShare } from "@fortawesome/free-solid-svg-icons";

function ContatoPage() {
  return (
    <main>
      <section id="contato" className={classes.formulario}>
        <div className="interface">
          <h2 className="titulo">FALE<span> CONOSCO.</span></h2>

          <form action="">
            <input type="text" name="nome" id="nome" placeholder="Seu nome" required />
            <input type="text" name="email" id="email" placeholder="Seu e-mail" required />
            <input type="text" name="telefone" id="telefone" placeholder="Seu celular" required />
            <textarea name="mensagem" id="mensagem" placeholder="Sua mensagem" required></textarea>
            <div className={classes.btnEnviar}>
              <div className={`btnContato ${classes.btnContato}`}>
                <a href='/servicos'><button><FontAwesomeIcon icon={faShare} />&nbsp;&nbsp;ENVIAR</button></a>
              </div>
            </div>
          </form>
        </div>
      </section>
      <br />
    </main>
  );
}

export default ContatoPage;